import React from 'react';
import { mergeStyles } from '@fluentui/react';
import { IParagraphOrHeaderComponentModel } from '../../parser/paragraph-header';

export const MarkdownParagraph: React.FunctionComponent<IParagraphOrHeaderComponentModel> = (props) => {
  const className = mergeStyles([{
    lineHeight: '1.5em',
    margin: 0,
    marginBottom: '1em',

    '& > img': {
      display: 'block',
      border: 0,
      margin: '1em 0',
      padding: 0,
      maxWidth: '100%',
    },
  }]);

  return (
    <p className={className} dangerouslySetInnerHTML={{ __html: props.text }} />
  );
};
